import styled from "styled-components";
import {Container, Text1} from "../../../../styles/business-components";

export const CustomContainer = styled(Container)`
  margin-top: 200px;
  background: ${({theme}) => `url('data:image/svg+xml,<svg width="1920" height="114" viewBox="0 0 1920 114" fill="${theme.business.colors.primaryBackground}" xmlns="http://www.w3.org/2000/svg"><path d="M0 114V64.7001C185.9 0.200142 385.3 -33.8999 827.9 52.3001C1270.7 138.5 1723.4 112.3 1919.8 55.3001H1920V114H0Z"/></svg>') bottom no-repeat ${theme.business.colors.cardBackground1}`};
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  
  @media only screen and (${({theme}) => theme.media.large}) {
    flex-direction: row;
    gap: 0;
  }
`

export const Image2 = styled.img`
  transition-duration: 0.96s;
  opacity: 0;
  width: 100%;
`

export const Image = styled.img`
  transition-duration: 0.96s;
  position: absolute;
  opacity: 1;
  width: 100%;
  z-index: 100;
`

export const ImageBlock = styled.div`
  position: relative;
  width: 100%;
  
  &:hover ${Image} {
    opacity: 0;    
  }

  &:hover ${Image2} {
    opacity: 1;
  }

  @media only screen and (${({theme}) => theme.media.large}) {
    width: 60%;
  }
`

export const TextBlock = styled.div`
  width: 100%;
  gap: 40px;
  display: flex;
  flex-flow: column;
  align-items: center;

  @media only screen and (${({theme}) => theme.media.large}) {
    width: 40%;
    align-items: flex-end;
  }
`

export const Text = styled(Text1)`
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;

  @media only screen and (${({theme}) => theme.media.large}) {
    font-size: 18px;
    line-height: 40px;
  }

  @media only screen and (${({theme}) => theme.media.ultraLarge}) {
    font-size: 24px;
    line-height: 60px;
    margin-bottom: 20px;
  }
`